import axios from "axios";
import { BaseURL } from "./baseUrl";

// get request handler
export const getRequest = async (url, params = null) => {
  try {
    return await axios.get(BaseURL + url, {
      params: params,
    });
  } catch (error) {
    return error.response;
  }
};

// post request handler
export const postRequest = async (url, body = null, header = null) => {
  try {
    return await axios.post(BaseURL + url, body, header);
  } catch (error) {
    return error.response;
  }
};

// put request handler
export const putRequest = async (url, body = null) => {
  try {
    return await axios.put(BaseURL + url, body);
  } catch (error) {
    return error.response;
  }
};

// patch request handler
export const patchRequest = async (url, body = null) => {
  try {
    return await axios.patch(BaseURL + url, body);
  } catch (error) {
    return error.response;
  }
};

// delete request handler
export const deleteRequest = async (url, body = null) => {
  try {
    return await axios.delete(BaseURL + url, { data: body });
  } catch (error) {
    return error.response;
  }
};
